import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { intranetPrimeNgTheme } from './@core/theme/primeng-theme';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { PortalLayoutComponent } from './portal-layout/portal-layout.component';
import { GlobalAlertComponent } from './global-alert/global-alert.component';
import { CoreModule } from './@core/core.module';
import { JwtInterceptor } from './@core/interceptor/jwt.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    LoginComponent,
    ChangePasswordComponent,
    PortalLayoutComponent,
    GlobalAlertComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    CoreModule,
    FormsModule,
    NgxSpinnerModule
  ],
  providers: [
    MessageService,
    providePrimeNG({ theme: intranetPrimeNgTheme }),
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class AppModule { }
